import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { HttpErrorInterceptor } from './interceptor/http-error.interceptor';
import { CustomerAccountsModule } from './modules/customer-accounts/customer-accounts.module';
import { HomeModule } from './modules/home/home.module';
//
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { NewAgentApiService } from './services/new-agent-api.service';
// import { ApiService } from './services/api.service';
import { HeaderComponent } from './components/common/header/header.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { SidenavComponent } from './components/common/sidenav/sidenav.component';
import { AlertsComponent } from './components/common/alerts/alerts.component';


import { environment } from 'src/environments/environment';
import { LoggerModule } from 'ngx-logger';
import { DashboardComponent } from './components/dashboard/deshboard/dashboard.component';
import { CaseManagementCardComponent } from './components/dashboard/case-management-card/case-management-card.component';
import { LogoutPageComponent } from './components/logout-page/logout-page.component';
import { MainComponent } from './components/main/main.component';
import { UserProfileDataCardComponent } from './components/user-profile-data-card/user-profile-data-card.component';
//import { InteractionHistoryComponent } from './components/customerAccounts/interaction-history/interaction-history.component';
import { FilterDataComponent } from './components/customerAccounts/filter-data/filter-data.component';
import { StyleguideComponent } from './components/styleguide/styleguide.component';
import { SsofailureComponent } from './components/ssofailure/ssofailure.component';
import { ALISRegistrationComponent } from './components/dashboard/alis-registration/alis-registration.component';
import { SharedModule } from './modules/shared module/shared.module';
import { SpeedTestModule } from 'ng-speed-test';
import { TbaRegistrationComponent } from './components/dashboard/tba-registration/tba-registration.component';
import { PaginationComponent } from './components/customerAccounts/pagination/pagination.component';
import { OpenMessageComponent } from './components/customerAccounts/open-message/open-message.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DashboardFilterComponent } from './components/dashboard/dashboard-filter/dashboard-filter.component';
import { AgentInteractionHistoryComponent } from './components/dashboard/agent-interaction-history/agent-interaction-history.component';
import { AppointmentsCardComponent } from './components/dashboard/appointments-card/appointments-card.component';
import { UnknownCallerComponent } from './components/customerAccounts/unknown-caller/unknown-caller.component';
//import { AlightSmartSearchDropDownComponent } from './alight-smart-search-drop-down/alight-smart-search-drop-down.component';

//import { DomainDetailsComponent } from './components/customerAccounts/domain-details/domain-details.component';

//import { TestRoutingModule } from './components/test/test-routing.module';
const environmentConfig: any = environment.logger;
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    DashboardComponent,
    AlertsComponent,
    CaseManagementCardComponent,
    LogoutPageComponent,
    MainComponent,
    UserProfileDataCardComponent,
    // InteractionHistoryComponent,
    FilterDataComponent,
    StyleguideComponent,
    SsofailureComponent,
    ALISRegistrationComponent,
    TbaRegistrationComponent,
    PaginationComponent,
    OpenMessageComponent,
    DashboardFilterComponent,
    AgentInteractionHistoryComponent,
    AppointmentsCardComponent,
    //UnknownCallerComponent,


    // CustomerSearchUnidentifiedCallComponent
    //DomainDetailsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    HomeModule,
    SharedModule,
    CustomerAccountsModule,
    SpeedTestModule, NgIdleKeepaliveModule.forRoot(),
    LoggerModule.forRoot({
      //serverLoggingUrl: environment.apiUrl + Global.customerApi.lambda,//where you give the full path to your api end-point for logging to server. This is optional, if you don’t need logs to be sen’t to server, delete this line.
      level: environmentConfig.level, //defines the minimum log level in the browser. Available levels are: TRACE, DEBUG, INFO, LOG, WARN, ERROR, FATAL and OFF. These values come from NgxLoggerLevel class.
      // serverLogLevel: environmentConfig.serverLogLevel,//defines the minimum log level for server-side logging.
      //disableConsoleLogging :true //disable all console log
    }),
    // TestRoutingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
